import React from 'react';
import Page from '../Page';
import LoadingBanner from "../../components/LoadingBanner";
import ErrorBanner from "../../components/ErrorBanner";
import Opportunity from "../../models/Opportunity";
import OppBriefStep from "./OppBriefStep";
import TalentPortal from "../talent-portal/TalentPortal";
import OppContractStep from "./OppContractStep";
import OppTeamStatusStep from "./OppTeamStatusStep";
import LinesEllipsis from 'react-lines-ellipsis'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import OppDashboard from "./OppDashboard";
import {
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
    generatePath,
    Link,
    Outlet
} from "react-router-dom";
import { useOpportunity } from "../../providers/OpportunityProvider";
import { useAuth } from "../../providers/AuthProvider";
import { OppProposalModal } from "../proposals/OppProposalWalkthrough";

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis)

export default class OpportunityDetails extends Page {
    static path = '/talent/project/:oppId';

    static handle = {
        "Opportunities@updated": async (component, opportunity) => {
            // console.log('Opportunities@updated', opportunity)
            if (component.props.opportunity?.id === opportunity?.id && !component.state.isLoading) {
                if (opportunity.project.is_on_hold) {
                    await TB.sysAlert('talent.opportunity_disabled_project_on_hold');
                    return component.props.navigate(opportunity.oppListWithSimilarStatus(), { replace: true })
                } else if (opportunity.status === Opportunity.Statuses.Lost) {
                    await TB.sysAlert('talent.opportunity_disabled_lost');
                    return component.props.navigate(opportunity.oppListWithSimilarStatus(), { replace: true })
                } else if (!opportunity.detailedViewAvailable()) {
                    return component.props.navigate(opportunity.oppListWithSimilarStatus(), { replace: true })
                } else {
                    component.setState({ opportunity })
                }
            }
        }
    };

    static pathForOpp(oppId, step) {
        if (TB.isObject(oppId)) {
            oppId = oppId.id;
        }

        let path = this.path;

        if (step && step.path) {
            path += step.path;
        }

        return generatePath(path, { oppId })
    }


    static steps(opportunity) {

        if (opportunity.isProposingWithTeam()) {
            return [
                OppDashboard,
                OppBriefStep,
                OppTeamStatusStep,
                OppContractStep
            ]
        }

        return [
            OppDashboard,
            OppBriefStep,
            OppContractStep
        ]
    };


    constructor(props) {
        super(props);

        this.routeRef = React.createRef();
        this.state = {
            isLoading: true
        }
    }

    async componentDidMount() {
        super.componentDidMount();
        let {
            opportunity
        } = this.props;
        if (opportunity.project.is_on_hold) {
            await TB.sysAlert('talent.opportunity_disabled_project_on_hold');
            return this.props.navigate(TalentPortal.projectsListPath(), { replace: true })
        } else if (opportunity.status === Opportunity.Statuses.Lost) {
            await TB.sysAlert('talent.opportunity_disabled_lost');
            return this.props.navigate(opportunity.oppListWithSimilarStatus(), { replace: true })
        } else if (!opportunity.detailedViewAvailable()) {
            return this.props.navigate(opportunity.oppListWithSimilarStatus(), { replace: true })
        }
    }

    // async loadOpportunity() {
    //     let {
    //         opportunity
    //     } = this.props;
    //     if (opportunity.project.is_on_hold) {
    //         await TB.sysAlert('talent.opportunity_disabled_project_on_hold');
    //         return this.props.navigate(TalentPortal.projectsListPath(), {replace: true})
    //     } else if (opportunity.status === Opportunity.Statuses.Lost) {
    //         await TB.sysAlert('talent.opportunity_disabled_lost');
    //         return this.props.navigate(opportunity.oppListWithSimilarStatus(), {replace: true})
    //     } else if (!opportunity.detailedViewAvailable()) {
    //         return this.props.navigate(opportunity.oppListWithSimilarStatus(), {replace: true})
    //     }
    //     await this.promisedState({opportunity, isLoading: false});
    //
    // }

    renderAdminTopBar() {
        let {
            opportunity
        } = this.props;

        if (!opportunity) {
            return null;
        }

        return (
            <div className="project-nav" style={{ height: '75px' }}>

                {/* <div className="project-nav-back hidden d-mflex"> */}
                <div className="project-nav-back hidden md:flex">

                    <Link to={TalentPortal.projectsListPath()}>
                        <i className="fa fa-arrow-left mr-2" />
                        Projects
                    </Link>

                </div>

                <div className="project-nav-info">
                    <div className="opportunity-title-container">
                        <Link className="opportunity-mobile-back-btn md:hidden" to={TalentPortal.projectsListPath()}>
                            <i className="fa fa-arrow-left" />
                        </Link>
                        <ResponsiveEllipsis
                            text={opportunity.project.name}
                            className="opportunity-nav-title"
                            maxLine={2}
                            ellipsis='...'
                            trimRight
                            basedOn='letters'
                        />

                    </div>

                    {this.renderNavigation()}
                </div>

                {/* <div className="project-nav-type hidden d-mflex justify-center"> */}
                <div className="project-nav-type hidden md:flex justify-center">
                    <div>
                        <h5 className="project-type-label">
                            Project Type
                        </h5>
                        <p className="project-type-name">
                            {opportunity.displayType()}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    renderMenu() {
        if (!this.props.opportunity?.project || this.context.auth?.isTalentSupplierResource()) {
            return <div />;
        }

        const steps = this.constructor.steps(this.props.opportunity);

        return (
            <div className="order-3 m-auto w-full basis-full md:basis-auto md:order-2 md:flex-1 lg:flex-none lg:flex justify-center">
                <div className="lg:inline-flex">

                    {steps.map((step, index) => {
                        const isActive = this.props.location.pathname.indexOf(step.path) > 0;
                        const isLocked = step.isLocked?.(this.props.opportunity);
                        const badge = step.badgeForOpp?.(this.props.opportunity);

                        return (
                            <Link
                                key={step.title}
                                to={this.constructor.pathForOpp(this.props.opportunity.id, step)}
                                className={TB.mapClass('min-w-[140px] text-center relative py-2 px-6 block w-full lg:w-auto text-white border border-[#3F434A]', {
                                    'bg-primary-100': isActive,
                                    'bg-charcoal-300': !isActive,
                                    'rounded-t-xl lg:rounded-none lg:rounded-l-xl': index === 0,
                                    'rounded-b-xl lg:rounded-none lg:rounded-r-xl': index === steps.length - 1,
                                    'bg-transparent': isLocked,
                                })}
                            >
                                <i className={TB.mapClass('mr-2', {
                                    'fas fa-lock': isLocked,
                                })}
                            />
                                {step.title}
                                &nbsp;
                                {badge && <span className='opp-details-badge'>{badge}</span>}
                            </Link>
                        )
                    })}
                </div>
            </div>
        )
    }

    renderTopBar() {
        let {
            opportunity
        } = this.props;
        if (!opportunity) {
            return null;
        }

        let auth = this.context.auth;
        if (!auth) {
            return null;
        }

        if (auth.canManageTalent()) {
            return this.renderAdminTopBar()
        }

        const isVisitingDashboard = this.props.location.pathname.indexOf('proposal') !== -1;

        return (
            <div className="project-nav">

                <div className="project-nav-back hidden md:flex">
                    {isVisitingDashboard && (
                        <Link to={TalentPortal.dashboardPath()} className="dashboard-home-btn hidden lg:flex">
                            <i className="fa fa-th text-lg text-white" />
                            <p className="text-white mb-0 mt-2">
                                {TB.trans('talent.dashboard.nav_info')}
                            </p>
                        </Link>
                    )}
                    <Link to={TalentPortal.projectsListPath()} className="whitespace-nowrap">
                        <i className="fa fa-arrow-left mr-2" />
                        Projects
                    </Link>

                </div>

                <div className="project-nav-info pb-4">
                    <div className="opportunity-title-container">
                        <Link className="opportunity-mobile-back-btn md:hidden" to={opportunity.oppListWithSimilarStatus()}>
                            <i className="fa fa-arrow-left" />
                        </Link>
                        <ResponsiveEllipsis
                            text={opportunity.project.name}
                            className="opportunity-nav-title"
                            maxLine={2}
                            ellipsis='...'
                            trimRight
                            basedOn='letters'
                        />

                    </div>
                    {this.renderMenu()}
                </div>

                <div className="project-nav-type hidden md:flex justify-center">
                    <div>
                        <h5 className="project-type-label">
                            Project Type
                        </h5>
                        <p className="project-type-name">
                            {opportunity.displayType()}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    currentStepIndex() {
        let opportunity = this.props.opportunity;
        return TB.findIndex(this.constructor.steps(opportunity), step => {
            let stepUrlPath = this.constructor.pathForOpp(opportunity, step);

            return this.props.location.pathname === stepUrlPath
                || this.props.location.pathname.startsWith(stepUrlPath)
        })
    }

    renderNavigation() {
        if (!this.props.opportunity?.project || this.context.auth?.isTalentSupplierResource()) {
            return <div />;
        }
        let steps = this.constructor.steps(
            this.props.opportunity
        );

        return (
            <div className="talent-portal-nav">
                <div className="opportunity-nav visible">
                    {steps.map((step, index) => {
                        let isActive = this.props.location.pathname.indexOf(step.path) > 0;
                        let isLocked = step.isLocked?.(this.props.opportunity);

                        return (
                            <div key={step.title}
                                className={TB.mapClass("step", {
                                    "middle-step-border": index > 0 && index < (steps.length - 1)
                                })}>
                                <Link
                                    className={TB.mapClass('text-underline', {
                                        "isLocked": step.isLocked?.(this.props.opportunity),
                                        "clickable": !isActive,
                                        "cursor-none active active-step": isActive
                                    })}
                                    to={this.constructor.pathForOpp(this.props.opportunity.id, step)}
                                >
                                    {step.accomplished && !isLocked && <i className="fas fa-check mr-2" />}
                                    {isLocked && <i className="fas fa-lock mr-2" />}
                                    {step.title}{step.badgeForOpp?.(this.props.opportunity)}
                                </Link>

                            </div>
                        )
                    })}
                </div>


            </div>
        )
    }

    render() {
        let {
            isLoading, opportunity
        } = this.props;

        let firstTime = this.queryParams?.firstTime
        let auth = this.context.auth;
        if (!auth) {
            return <div />;
        }

        return (
            <div className="talent-portal-page">

                {!firstTime && opportunity && this.renderTopBar()}

                {!firstTime && opportunity && auth.canManageTalent() && opportunity.talentUser() && (
                    <div className="nav-alert nav-danger">
                        <p>
                            <i className="fa fa-exclamation-circle" /> Currently Viewing Opportunity
                            as <b>{opportunity.talentUser().fullName()}</b>
                        </p>
                    </div>
                )}

                {isLoading && <LoadingBanner message="Loading Project" />}

                {!isLoading && (
                    <React.Fragment>

                        {this.props.children}
                        <OppProposalModal />
                    </React.Fragment>
                )}

            </div>
        );
    }
}

const OppRouter = (props) => {
    const { oppId } = useParams();
    const [queryParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { auth } = useAuth();

    const {
        isLoading,
        error,
        opportunity,
        disabled,
        updateOpportunity,
        refetch,
        onRequest,
        isDisabled
    } = useOpportunity();

    // useEffect(() => {
    //     const resetPage = async () => {
    //         if (isLoading || !opportunity) {
    //             return;
    //         }
    //         if (opportunity.project?.is_on_hold) {
    //             await TB.sysAlert('talent.opportunity_disabled_project_on_hold');
    //             return navigate(TalentPortal.projectsListPath(), {replace: true})
    //         } else if (opportunity?.status === Opportunity.Statuses.Lost) {
    //             await TB.sysAlert('talent.opportunity_disabled_lost');
    //             return navigate(opportunity.oppListWithSimilarStatus(), {replace: true})
    //         } else if (!opportunity.detailedViewAvailable()) {
    //             return navigate(opportunity.oppListWithSimilarStatus(), {replace: true})
    //         }
    //     }
    //     resetPage();
    // }, [isLoading, opportunity?.status, opportunity?.project?.is_on_hold]);


    if (isLoading) {
        return (
            <div className="talent-portal-page">
                <LoadingBanner message="Loading Project" />
            </div>
        )
    }

    if (error) {
        return (
            <div className="talent-portal-page">
                <ErrorBanner
                    title={"Something went wrong"}
                    message={"Failed to load project. Please try again"}
                    onRetry={refetch} />
            </div>
        )
    }

    // if (opportunity && opportunity.isActive()) {
    //     return <Navigate to={`/${auth.talentPortalType()}/project/${opportunity.id}/review-contract`} replace={true}/>
    // }

    return (
        <OpportunityDetails
            opportunity={opportunity}
            disabled={disabled}
            location={location}
            updateOpportunity={updateOpportunity}
            navigate={navigate}
            onRequest={onRequest}
            isDisabled={isDisabled}
            queryParams={queryParams}
            oppId={oppId}
        >
            <Outlet />
        </OpportunityDetails>
    )

}
export {
    OppRouter
}